/**
 * Workaround for HUB-1089. Should only be used on forms with password fields.
 * This directive keeps form.$submitted in the correct state, while preventing
 * a browser from thinking the form has been submitted.
 *
 * @example: <button password-form-submit>Submit</button>
 */
export default /* @ngInject */ function($document) {
    const suggestNavKeys = [33, 34, 39, 40]; // pgdn, pgup, down, up
    return {
        require: '^form',
        link: function(scope, element, attrs, formCtrl) {
            let prevKey = null;
            let handleKey = (event) => {
                // Pressing a autosuggest navigate keys indicates that the user
                // was in the autosuggest menu, where enter should select a
                // suggestion instead of fake-submitting the form.
                if (-1 === suggestNavKeys.indexOf(prevKey) &&
                    formCtrl[event.target.name] && // Input in form
                    event.keyCode === 13 // Enter key
                ) {
                    formCtrl.$setSubmitted();
                    scope.$apply();
                }
                prevKey = event.keyCode;
            };

            // Catch form submit using enter key.
            $document.on('keydown', handleKey);
            scope.$on('$destroy', () => $document.off('keydown', handleKey));

            // Catch form submit by clicking the submit button.
            element.on('click', () => formCtrl.$setSubmitted());

            // Prevent submit on invalid forms by switching to type=button when
            // the form is invalid, and type=submit when the form is valid.
            scope.$watch(() => formCtrl.$valid, (valid) => {
                element.attr('type', valid ? 'submit' : 'button');
            });
        }
    };
}



// WEBPACK FOOTER //
// ./forms/directives/password-form-submit.js